import React from "react";
import { getValue } from "@utils/lodash";

function UploadSubheaderSvgComponent(props: any) {
  return (
    <>
    <svg xmlns="http://www.w3.org/2000/svg"  height={
      getValue(props, `size`, "") ? getValue(props, `size`, "") : "32px"
    }
    width={
      getValue(props, `size`, "") ? getValue(props, `size`, "") : "32px"
    } viewBox="0 0 32 32">
      <defs>
        <clipPath id="clip-path-upload">
          <rect id="Rectangle_18221" data-name="Rectangle 18221" width="32" height="32" transform="translate(-14345 -8244)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Group_10481" data-name="Group 10481" transform="translate(-1237 -73)">
        <rect id="Rectangle_17982" data-name="Rectangle 17982" width="32" height="32" rx="4" transform="translate(1237 73)" fill="#f2f2f2"/>
        <g id="Mask_Group_325" data-name="Mask Group 325" transform="translate(15586 8321)" clip-path="url(#clip-path-upload)">
          <path id="upload_2_FILL0_wght300_GRAD0_opsz24" d="M5.684-10.158V-11.5h14v1.342Zm4.5-3.476V-19.8H6.788l5.9-7.356L18.571-19.8H15.179v6.169h-5Zm1.4-1.342h2.2v-6.177H15.7l-3.012-3.82-3.021,3.82H11.58v6.177ZM12.684-21.153Z" transform="translate(-14345.685 -8213.342)" fill={
          getValue(props, `color`, "")
            ? getValue(props, `color`, "")
            : "#5f6368"
        } />
        </g>
      </g>
    </svg>
    </>
  );
}

export default UploadSubheaderSvgComponent;
